import React from 'react';
import { motion } from 'framer-motion';
import { Settings, Wifi, Download, Eye } from 'lucide-react';

const QualitySettings = ({ currentQuality, onQualityChange, onDownloadQualityChange }) => {
  const qualities = [
    { id: 'auto', label: 'Automático', description: 'Se adapta a tu conexión', bitrate: 'Variable' },
    { id: '4k', label: '4K Ultra HD', description: 'Máxima calidad', bitrate: '25 Mbps' },
    { id: '1080p', label: '1080p Full HD', description: 'Alta calidad', bitrate: '8 Mbps' },
    { id: '720p', label: '720p HD', description: 'Calidad estándar', bitrate: '4 Mbps' },
    { id: '480p', label: '480p', description: 'Ahorra datos', bitrate: '1.5 Mbps' }
  ];

  const downloadQualities = [
    { id: '1080p', label: '1080p Full HD', size: '1.5 GB' },
    { id: '720p', label: '720p HD', size: '800 MB' },
    { id: '480p', label: '480p', size: '400 MB' }
  ];

  return (
    <div className="p-6 space-y-8">
      <div className="flex items-center gap-3">
        <Settings className="w-6 h-6 text-red-400" />
        <h2 className="text-2xl font-bold text-white">Configuración de Calidad</h2>
      </div>

      {/* Calidad de Streaming */}
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <Wifi className="w-5 h-5 text-blue-400" />
          <h3 className="text-lg font-semibold text-white">Calidad de Streaming</h3>
        </div>
        
        <div className="grid gap-3">
          {qualities.map((quality, index) => (
            <motion.label
              key={quality.id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              className={`flex items-center gap-4 p-4 rounded-lg border cursor-pointer transition-all ${
                currentQuality === quality.id
                  ? 'bg-red-500/20 border-red-500/50'
                  : 'bg-gray-800/50 border-gray-700/50 hover:border-gray-600/70'
              }`}
            >
              <input
                type="radio"
                name="streaming-quality"
                value={quality.id}
                checked={currentQuality === quality.id}
                onChange={(e) => onQualityChange(e.target.value)}
                className="text-red-500 focus:ring-red-500"
              />
              <div className="flex-1">
                <div className="text-white font-semibold">{quality.label}</div>
                <div className="text-gray-400 text-sm">{quality.description}</div>
              </div>
              <div className="text-gray-400 text-sm">{quality.bitrate}</div>
            </motion.label>
          ))}
        </div>
      </div>

      {/* Calidad de Descargas */}
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <Download className="w-5 h-5 text-green-400" />
          <h3 className="text-lg font-semibold text-white">Calidad de Descargas</h3>
        </div>
        
        <div className="grid gap-3">
          {downloadQualities.map((quality, index) => (
            <motion.label
              key={quality.id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              className="flex items-center gap-4 p-4 bg-gray-800/50 rounded-lg border border-gray-700/50 hover:border-gray-600/70 cursor-pointer transition-all"
            >
              <input
                type="radio"
                name="download-quality"
                value={quality.id}
                className="text-green-500 focus:ring-green-500"
              />
              <div className="flex-1">
                <div className="text-white font-semibold">{quality.label}</div>
                <div className="text-gray-400 text-sm">Tamaño aproximado: {quality.size}</div>
              </div>
            </motion.label>
          ))}
        </div>
      </div>

      {/* Información de Uso */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="p-4 bg-blue-500/10 border border-blue-500/30 rounded-lg"
      >
        <div className="flex items-start gap-3">
          <Eye className="w-5 h-5 text-blue-400 mt-0.5" />
          <div>
            <h4 className="text-blue-400 font-semibold mb-1">Recomendación</h4>
            <p className="text-blue-300 text-sm">
              Para la mejor experiencia, usa "Automático". El sistema ajustará la calidad según tu velocidad de internet.
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default QualitySettings;